<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M5 2H19C19.5523 2 20 2.44772 20 3V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V3C4 2.44772 4.44772 2 5 2Z"
      stroke="currentColor"
      stroke-width="2"
    />
    <rect
      x="20"
      y="15"
      width="1.57"
      height="16"
      rx="0.5"
      transform="rotate(90 20 15)"
      fill="currentColor"
    />
    <rect
      x="17.43"
      y="18"
      width="1.23"
      height="10"
      rx="0.5"
      transform="rotate(90 17 18)"
      fill="currentColor"
    />
    <circle
      cx="12"
      cy="7.33333"
      r="2.5"
      stroke="currentColor"
      stroke-width="1.66667"
    />
    <path
      d="M11.1481 12.333H12.8522C15.0373 12.333 16.8264 14.023 16.987 16.167H7.01337C7.17398 14.023 8.96309 12.333 11.1481 12.333Z"
      stroke="currentColor"
      stroke-width="1.66667"
    />
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box',
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
  },
}
</script>
